/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calm_Swift_Deer_BoundInputs */

const en_calm_swift_deer_bound = /** @type {(inputs: Calm_Swift_Deer_BoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rounding`)
};

const de_calm_swift_deer_bound = /** @type {(inputs: Calm_Swift_Deer_BoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rundung`)
};

/**
* | output |
* | --- |
* | "Rounding" |
*
* @param {Calm_Swift_Deer_BoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const calm_swift_deer_bound = /** @type {((inputs?: Calm_Swift_Deer_BoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calm_Swift_Deer_BoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calm_swift_deer_bound(inputs)
	return de_calm_swift_deer_bound(inputs)
});